module.exports = __webpack_public_path__ + "img/game-map.43f621ed.png";